const e = "af-uservoice-click", s = class s extends CustomEvent {
  constructor(c) {
    super(e, { detail: c, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = e;
let t = s;
export {
  e as EVENT_NAME,
  t as default
};
//# sourceMappingURL=UservoiceEvent.js.map
